"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import Checkmark from "@crehana/compass.icons.outline/Checkmark";
import Search from "@crehana/compass.icons.outline/Search";
import { Command, CommandLoading, useCommandState } from "cmdk";
import { cn } from "../utils.js";
import * as __rspack_external_react from "react";
const command_Command = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(Command, {
        ref: ref,
        className: cn('tw-rounded tw-overflow-hidden', className),
        ...props
    }));
command_Command.displayName = Command.displayName;
const CommandInput = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsxs("div", {
        className: "tw-flex tw-items-center tw-border-solid tw-border-b tw-border-neutral-light-400 dark:tw-border-neutral-dark-500",
        "cmdk-input-wrapper": "",
        children: [
            /*#__PURE__*/ jsx(Search, {
                size: 24,
                className: "tw-ml-2.4 tw-mr-1.2 tw-shrink-0 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500"
            }),
            /*#__PURE__*/ jsx(Command.Input, {
                ref: ref,
                className: cn('tw-flex tw-w-full tw-pr-2.4 tw-py-1.2 tw-outline-none tw-font-body4', 'placeholder:tw-text-neutral-light-700 disabled:tw-cursor-not-allowed tw-text-neutral-light-800', 'dark:placeholder:tw-text-neutral-dark-500 dark:tw-text-neutral-light-100', 'tw-bg-transparent', className),
                ...props
            })
        ]
    }));
CommandInput.displayName = Command.Input.displayName;
const CommandList = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(Command.List, {
        ref: ref,
        className: cn('tw-max-h-24 tw-overflow-y-auto tw-min-w-[30rem] tw-max-w-[30rem] sm:tw-max-w-[50rem] md:tw-max-w-[80rem] lg:tw-max-w-[100rem]', className),
        ...props
    }));
CommandList.displayName = Command.List.displayName;
const CommandEmpty = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(Command.Empty, {
        ref: ref,
        className: cn('tw-py-5.6 tw-px-2.4 tw-text-center', className),
        ...props
    }));
CommandEmpty.displayName = Command.Empty.displayName;
const CommandGroup = /*#__PURE__*/ __rspack_external_react.forwardRef((props, ref)=>/*#__PURE__*/ jsx(Command.Group, {
        ref: ref,
        ...props
    }));
CommandGroup.displayName = Command.Group.displayName;
const CommandSeparator = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(Command.Separator, {
        ref: ref,
        className: cn('-mx-1 h-px bg-slate-200 dark:bg-slate-800', className),
        ...props
    }));
CommandSeparator.displayName = Command.Separator.displayName;
const CommandItemWithoutRef = ({ className, selected, children, searchKey, removeCheck, value, onSelect, ...props }, ref)=>/*#__PURE__*/ jsxs(Command.Item, {
        ref: ref,
        className: cn('tw-group tw-relative tw-flex tw-gap-1.2 tw-w-full tw-justify-between tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-outline-none', 'tw-font-body4 tw-py-1.2 tw-px-2.4 tw-min-h-4.8 dark:tw-text-neutral-light-100', 'data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50', 'aria-selected:tw-bg-neutral-light-300 dark:aria-selected:tw-bg-neutral-dark-600 aria-selected:tw-text-primary-light-500', selected && 'tw-text-primary-light-500', className),
        value: searchKey?.replace(/\n/g, ' '),
        onSelect: ()=>onSelect(value),
        ...props,
        children: [
            children,
            !removeCheck && /*#__PURE__*/ jsx("span", {
                className: "tw-flex tw-items-center tw-w-2.4 tw-h-full",
                children: selected && /*#__PURE__*/ jsx(Checkmark, {
                    className: "tw-text-success-400",
                    size: 24
                })
            })
        ]
    });
const CommandItem = /*#__PURE__*/ __rspack_external_react.forwardRef((props, ref)=>CommandItemWithoutRef(props, ref));
const CommandShortcut = ({ className, ...props })=>/*#__PURE__*/ jsx("span", {
        className: cn('ml-auto text-xs tracking-widest text-slate-500 dark:text-slate-400', className),
        ...props
    });
CommandShortcut.displayName = 'CommandShortcut';
export { Command as CommandPrimitive, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandLoading as CommandLoadingPrimitive, CommandSeparator, CommandShortcut, command_Command as Command, useCommandState };
